import React from "react";
import styled from "styled-components";
import ViewAppBar from "../views/ViewAppBar";
import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";
import ViewCadastroPropriedade from "../views/ViewCadastroPropriedade";
import { Row } from "antd";

const ContainerComponente = styled.div`
  display: grid;

  @media (min-width: 200px) and (max-width: 299px) {
    grid-template-rows: 140px 1fr auto;
  }
  @media (min-width: 300px) and (max-width: 399px) {
    grid-template-rows: 140px 1fr auto;
  }
  @media (min-width: 400px) and (max-width: 499px) {
    grid-template-rows: 140px 1fr auto;
  }
  @media (min-width: 500px) {
    grid-template-rows: 130px 1fr auto;
  }
  @media (min-width: 1100px) {
    grid-template-rows: 100px 1fr auto;
  }
`;

const CadastroPropriedade: React.FC = () => (
  <ContainerComponente>
    <ContatoZap />
    <ViewAppBar />
    <ViewCadastroPropriedade />
    <ViewFooter />
  </ContainerComponente>
);

export default CadastroPropriedade;
